import React from 'react';
import PermissionGate from 'global/components/permission-gate';
import { withRouter } from 'react-router-dom';
import AssessmentTemplates from './assessmenttemplates';
import EditionList from './editions';
import Panels from '../../../global/components/panels';
import ScorecardList from './scorecards';
import TaskTypeList from '../task-types';
import { Text } from '../../../global/components/text';
import { TradesList } from '../vendors/trades';

export default PermissionGate(
  withRouter((props) => {
    const panels = [
      { 
        title: 'Content Configuration',
        panels: [
          { id: 'task-types', title: 'Task Types', component: (p) => <TaskTypeList {...p} /> },
          { id: 'trade-types', title: 'Trade Types', component: (p) => <TradesList {...p} /> },
        ]
      },
      { 
        title: 'Content Management',
        panels: [
          { id: 'editions', title: 'Editions', component: (p) => <EditionList {...p} /> },
          // { id: 'scorecards', title: 'Scorecards', component: p => <AssessmentTemplates {...p} /> },
          { id: 'templates', title: 'Assessment Templates', component: (p) => <AssessmentTemplates {...p} /> },
          { id: 'scorecards', title: 'Scorecards', component: (p) => <ScorecardList {...p} /> },
        ]
      }
    ]

    return panels.map(p => <Panels title={p.title} panels={p.panels} defaultPanel={99} />)
  })
);
